export const ASM_LAST_AGENT_USER_ID_LOCAL_STORAGE_KEY = 'asm_user_agent_id';
